import PropTypes from 'prop-types';
import { Mediator } from '@spotahome/soyuz-mediator';
import { formatDate, CHANNELS } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { certificateIsUnavailable } from '../../utils';

import ListingEnergyCertificateValue from '../ListingEnergyCertificateValue';
import ListingEnergyCertificateModalInfoRow from '../ListingEnergyCertificateModalInfoRow';

import './ListingEnergyCertificateModal.scss';

const ListingEnergyCertificateModalContent = ({
  energyCertificate,
  emissionsCertificate = null
}) => {
  const {
    value: energyCertificateValue,
    additionalInfo: energyCertificateInfo
  } = energyCertificate || {};

  const {
    value: emissionsCertificateValue,
    additionalInfo: emissionsCertificateInfo
  } = emissionsCertificate || {};

  const showEnergyCertificateRequested = certificateIsUnavailable(
    energyCertificateValue
  );

  const showEmissionsCertificateRequested = certificateIsUnavailable(
    emissionsCertificateValue
  );

  return (
    <div className="listing-energy-certificate-modal">
      <div className="listing-energy-certificate-modal__diagram">
        <div className="listing-energy-certificate-modal__row">
          <span className="listing-energy-certificate-modal__subtitle">
            {trans('listing.energy-certificate.title.most-efficient')}
          </span>
          <div className="listing-energy-certificate-modal__content">
            <ListingEnergyCertificateValue value="A" />
            <ListingEnergyCertificateValue value="B" />
            <ListingEnergyCertificateValue value="C" />
          </div>
        </div>
        <div className="listing-energy-certificate-modal__row">
          <span className="listing-energy-certificate-modal__subtitle">
            {trans('listing.energy-certificate.title.medium')}
          </span>
          <div className="listing-energy-certificate-modal__content">
            <ListingEnergyCertificateValue value="D" />
            <ListingEnergyCertificateValue value="E" />
          </div>
        </div>
        <div className="listing-energy-certificate-modal__row">
          <span className="listing-energy-certificate-modal__subtitle">
            {trans('listing.energy-certificate.title.least-efficient')}
          </span>
          <div className="listing-energy-certificate-modal__content">
            <ListingEnergyCertificateValue value="F" />
            <ListingEnergyCertificateValue value="G" />
          </div>
        </div>
      </div>
      <ul className="listing-energy-certificate-modal__info">
        <ListingEnergyCertificateModalInfoRow
          title={trans('listing.energy-certificate.title')}
          certificateIsRequested={showEnergyCertificateRequested}
          renderCertificateInfo={() => (
            <ListingEnergyCertificateValue
              squared
              value={energyCertificateValue}
            />
          )}
        />
        <ListingEnergyCertificateModalInfoRow
          title={trans('listing.energy-certificate.row.energy-consumption')}
          certificateIsRequested={
            showEnergyCertificateRequested ||
            !energyCertificateInfo?.energyConsumption
          }
          renderCertificateInfo={() => (
            <span>{energyCertificateInfo.energyConsumption / 100} kWh/m2</span>
          )}
        />
        <ListingEnergyCertificateModalInfoRow
          title={trans('listing.energy-certificate.row.emissions')}
          certificateIsRequested={showEmissionsCertificateRequested}
          renderCertificateInfo={() => (
            <ListingEnergyCertificateValue
              squared
              value={emissionsCertificateValue}
            />
          )}
        />
        <ListingEnergyCertificateModalInfoRow
          title={trans('listing.energy-certificate.row.emissions-yearly')}
          certificateIsRequested={
            showEmissionsCertificateRequested ||
            !emissionsCertificateInfo?.emissions
          }
          renderCertificateInfo={() => (
            <span>{emissionsCertificateInfo.emissions / 100} kg CO2/m2</span>
          )}
        />
        <ListingEnergyCertificateModalInfoRow
          title={trans('listing.energy-certificate.row.date')}
          certificateIsRequested={
            showEnergyCertificateRequested ||
            !energyCertificateInfo?.certificationDate
          }
          renderCertificateInfo={() => (
            <span>
              {formatDate(
                new Date(energyCertificateInfo.certificationDate),
                'dd/MM/yyyy'
              )}
            </span>
          )}
        />
      </ul>
    </div>
  );
};

ListingEnergyCertificateModalContent.propTypes = {
  energyCertificate: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.shape({
      energyConsumption: PropTypes.number,
      certificationDate: PropTypes.string
    })
  }).isRequired,
  emissionsCertificate: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.shape({
      emissions: PropTypes.number
    })
  })
};

const openListingEnergyCertificateModal = ({
  energyCertificate,
  emissionsCertificate
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.energy-certificate.title'),
    body: (
      <ListingEnergyCertificateModalContent
        energyCertificate={energyCertificate}
        emissionsCertificate={emissionsCertificate}
      />
    ),
    fullscreenOnMobile: true
  });
};

export default openListingEnergyCertificateModal;
